class Circle {
  private parentContainer: HTMLElement | null;
  private initialY: number;

  constructor(private el: HTMLElement) {
    this.initialY = this.el.getBoundingClientRect().top + window.scrollY;
  }

  public updatePosition(scrolled: number): void {
    const rect = this.el.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const elementTop = rect.top + scrolled;
    const progress =
      (viewportHeight + scrolled - elementTop) / (viewportHeight + rect.height);

    const clampedProgress = Math.max(0, Math.min(progress, 1));

    this.el.style.transform = `translateY(${clampedProgress * 100}px)`;
  }
}

export default Circle;
